import $ from 'jquery';
import BaseView from '../core/baseView';
import * as config from '../../home24/core/config';

export default BaseView.extend({

    /**
     * @type {$[]}
     */
    $teasers: [],

    /**
     * @type {int}
     */
    activeTeaser: 0,

    /**
     * @type {bool}
     */
    blockTransition: false,

    /**
     * @type {int}
     */
    timeout: 0,

    /**
     * @type {int}
     */
    timeoutDelay: config.getInt('marketing.teaser.sliding.intervals.slide'),

    /**
     * @type {int}
     */
    touchStartX: 0,

    /**
     * @type {Number}
     */
    minTouchDistance: config.getInt('marketing.teaser.sliding.touch.distance'),

    initialize: function () {

        this.preInit();

        if (this.$el.data('timeout-delay')) {
            this.timeoutDelay = parseInt(this.$el.data('timeout-delay'), 10);
        }

        this.$teasers = this.$('.iframe[data-external-url], .teaser-element');

        if (this.$teasers.length > 0) {

            this.seedTeaser();

            this.$teasers.hide();
            this.$teasers.eq(this.activeTeaser).show();
        }

        if (this.$teasers.length > 1) {

            this.$el
                .on('mouseenter', $.proxy(this.onMouseEnter, this))
                .on('mouseleave', $.proxy(this.onMouseLeave, this));

            this.restartTimer();

        } else {
            this.toGlobalFallback();
        }

        this.postInit();

        $(window).on('AdBlockDetected', $.proxy(this.onAdBlockDetected, this));
    },

    cancelTimer: function () {
        if (this.timeout) {
            window.clearInterval(this.timeout);
        }
    },

    restartTimer: function () {
        this.cancelTimer();
        this.timeout = window.setInterval($.proxy(this.onTimeout, this), this.timeoutDelay);
    },

    /**
     * This pre-hook is executed before constructor logic
     */
    preInit: function () {

    },

    /**
     * This post-hook is executed after constructor logic
     */
    postInit: function () {

    },

    seedTeaser: function () {
        this.activeTeaser = 0;
    },

    /**
     * Handler executed every time adblock is detected.
     */
    onAdBlockDetected: function () {
        if (this.$('.content>.fallback').length > 0) {
            this.cancelTimer();
            this.toGlobalFallback();
        }
    },

    onMouseEnter: function () {
        this.blockTransition = true;
    },

    onMouseLeave: function () {
        this.blockTransition = false;
    },

    toGlobalFallback: function () {

    },

    postFadeTo: function () {

    },

    getNextTeaser: function () {
        var newActive = this.activeTeaser + 1;

        if (newActive >= this.$teasers.length) {
            newActive = 0;
        }

        return newActive;
    },

    getPrevTeaser: function () {
        var newActive = this.activeTeaser - 1;

        if (newActive < 0) {
            newActive = this.$teasers.length - 1;
        }

        return newActive;
    },

    /**
     * On touchstart handler for .content element inside teaser
     * @param {event} event
     */
    onTouchStart: function (event) {
        /*
         * In case of touch, abort all timing events, since they will interfere with touches
         */
        if (this.timeout) {
            window.clearInterval(this.timeout);
        }
        this.touchStartX = Math.round(event.originalEvent.touches[0].pageX);
    },

    /**
     * On touchend handler for .content element inside teaser
     * @param {event} event
     */
    onTouchEnd: function (event) {
        var iTouchDistance = event.originalEvent.changedTouches[0].pageX - this.touchStartX;

        if (Math.abs(iTouchDistance) > this.minTouchDistance) {
            if (iTouchDistance > 0) {
                this.fadeTo(this.getPrevTeaser());
                this.restartTimer();
            } else {
                this.fadeTo(this.getNextTeaser());
                this.restartTimer();
            }
        }
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/TeaserBaseView.js
 **/